import BulkUploadIncentiveMultipliersManager from "../../../views/BulkUploadIncentiveMultipliers";
import MenuNames from "../../../constants/Menu/MenuNames.json"

const BulkUploadIncentiveMultipliersManagerRoutes = [
  {
    menuName: MenuNames.INCENTIVE_MULTIPLIERS,
    path: "/bulk-upload-incentive-multipliers",
    component: BulkUploadIncentiveMultipliersManager,
    exact: true,
  },
];

export default BulkUploadIncentiveMultipliersManagerRoutes;